import { CIcon } from '~/icons/types'

export const ciMotorbikes: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M20.3 11.3c-.3 0-.7.1-1 .1l-.2-.5c.5-.1 1.3-.1 1.8-.1.2 0 .4 0 .5-.1.2 0 .3-.2.4-.3 0-.3.2-.699 0-1-.5-1.099-1.3-2.099-2.5-2.7L17 5.302c-.2-.1-.6 0-.7.2-.2.2-.2.6.1.7l1.7 1-1.5 1.2c-.7-.6-1.5-1-2.4-1.1h-.5c-.6-.1-1.9 0-2.8.9l-.6.6h-2l-.4-.5c-.2-.3-.5-.5-.9-.7-.4-.1-.8-.2-1.1-.2l-4 .1c-.5 0-.7.7-.4 1l5 3c.9.5 1.6 1.4 1.8 2.4l-1 .2C6 9.9 0 10.8 0 15c.1 4.9 7.3 4.8 7.3 0l1-.2v.8l-.2 1c0 .3.2.6.5.6l7 .5c.1 0 .2-.1.5-.3.1-.1.1-.3.1-.4l-.1-2.6c-.1-.6.1-1.2.4-1.8.3-.5.7-1 1.3-1.3.1 0 .2-.1.3-.1l.3.7c-3.1 1.9-1.7 6.8 1.9 6.8 2 0 3.6-1.6 3.7-3.7 0-2.1-1.6-3.7-3.7-3.7ZM3.7 17.8c-1.5 0-2.7-1.2-2.7-2.7 0-3 4.2-3.7 5.2-1l-2.8.5c-.6.2-.5 1 .1 1l2.9-.5c-.1 1.5-1.3 2.7-2.7 2.7Zm14.6-7.7c-.1 0-.1 0 0 0-.4.1-.7.2-1 .4-.7.4-1.3 1-1.7 1.7-.3.7-.5 1.5-.5 2.3l.1 2.1-5.9-.4c.6-2.099-.3-4.6-2.3-5.7L3.5 8.402l2.4-.1c.5-.1.9.2 1.3.5l.6.9c.1.1.2.2.4.2h2.5c.2 0 .3-.1.4-.2l.7-.9c.8-.7 1.7-.6 2.4-.6.8.1 1.5.5 2 1.1.2.2.5.3.8.1l2.1-1.7c.7.4 1.2 1 1.6 1.7l.3.4c-1 0-1.9 0-2.7.3Zm2 7.6c-2.6 0-3.6-3.4-1.6-4.9l1.1 2.6c.1.3.5.4.8.3.3-.2.3-.4.2-.7l-1.1-2.6c3.9-.7 4.6 5.1.6 5.3Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'motorbikes',
  type: 'thin'
}
